// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  approvedFrom: DateSchema,
  approvedTo: t.union([DateSchema, t.null]),
  subjectId: PositiveIntegerSchema,
  userProfileId: PositiveIntegerSchema,
});

export const CreateSubjectMemberSchema = excess(requiredPart);

export interface CreateSubjectMember extends t.TypeOf<typeof CreateSubjectMemberSchema> {}
